// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkboxes_checkbox__2NxkS","block":"Checkboxes_block__2OtRG","input":"Checkboxes_input__wRdoz","label":"Checkboxes_label__3NFFC"};